"use strict";
import { jsx } from "react/jsx-runtime";
export default function NotificationCtaButton(props) {
  return /* @__PURE__ */ jsx(
    "button",
    {
      "data-component": "NotificationCtaButton",
      className: "button--link-v2 button-small mb-0",
      onClick: props.onClick,
      children: props.children
    }
  );
}
